import {GenericoTipoEnum} from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum StatusPropostaParceiro {
  SemStatus = 'SemStatus',
  GerandoOferta = 'GerandoOferta',
  AguardandoAceite = 'AguardandoAceite', // Proposta Enviada
  EmAndamento = 'EmAndamento',
  Pago = 'Pago',
  Reprovada = 'Reprovada',
  Aprovada = 'Aprovada',
  Enviar = 'Aprovada',
  Pendente = 'Pendente',
  AguardandoCnd = 'AguardandoCnd',
  AguardandoProposta = 'AguardandoProposta',
  AguardandoDisponibilidade = 'AguardandoDisponibilidade',
  DocumentoPendente = 'DocumentoPendente',
  ValidandoDocumento = 'ValidandoDocumento',
  PropostaVencida = 'PropostaVencida',
  ContatoComCliente = 'ContatoComCliente',
}

export class StatusPropostaParceiroEnum extends GenericoTipoEnum<StatusPropostaParceiro> {
  static readonly AguardandoDisponibilidade = new StatusPropostaParceiroEnum(StatusPropostaParceiro.AguardandoDisponibilidade, 'Aguardando Disponibilidade');
  static readonly AguardandoProposta = new StatusPropostaParceiroEnum(StatusPropostaParceiro.AguardandoProposta, 'Aguardando Proposta');
  static readonly AguardandoAceite = new StatusPropostaParceiroEnum(StatusPropostaParceiro.AguardandoAceite, 'Aguardando Aceite');
  static readonly Aprovada = new StatusPropostaParceiroEnum(StatusPropostaParceiro.Aprovada, 'Aprovada');
  static readonly AguardandoCnd = new StatusPropostaParceiroEnum(StatusPropostaParceiro.AguardandoCnd, 'Aguardando Cnd');
  static readonly ValidandoDocumento = new StatusPropostaParceiroEnum(StatusPropostaParceiro.ValidandoDocumento, 'Validando Documento');
  static readonly DocumentoPedente = new StatusPropostaParceiroEnum(StatusPropostaParceiro.DocumentoPendente, 'Documento Pendente');
  static readonly EmAndamento = new StatusPropostaParceiroEnum(StatusPropostaParceiro.EmAndamento, 'Em Andamento');
  static readonly Pago = new StatusPropostaParceiroEnum(StatusPropostaParceiro.Pago, 'Pago');
  static readonly Reprovada = new StatusPropostaParceiroEnum(StatusPropostaParceiro.Reprovada, 'Reprovada');
  static readonly PropostaVencida = new StatusPropostaParceiroEnum(StatusPropostaParceiro.PropostaVencida, 'Proposta Vencida');
  //
  static readonly SemStatus = new StatusPropostaParceiroEnum(StatusPropostaParceiro.SemStatus, 'Sem Status');
  static readonly GerandoOferta = new StatusPropostaParceiroEnum(StatusPropostaParceiro.GerandoOferta, 'Gerando Oferta');
  static readonly Pendente = new StatusPropostaParceiroEnum(StatusPropostaParceiro.Pendente, 'Pendente');
  static readonly ContatoComCliente = new StatusPropostaParceiroEnum(StatusPropostaParceiro.ContatoComCliente, 'Alteração no valor');
}
